import React, {Fragment, useEffect, useRef, useState} from "react";
import {Chart, Interval, Tooltip, Line, Axis, Legend, Schema} from 'bizcharts';
import 'bootstrap/dist/css/bootstrap.min.css';
import {GComponents} from "bizcharts";
import Card from "react-bootstrap/Card";

const {
    Canvas,
} = GComponents;


const SingleSlidePlot = ({name, displayData,index,setIndex,id}) => {

    return (
        <Card className={"h-100 d-inline-block"} as={"a"} onClick={()=>setIndex(id)} style={{ cursor: "pointer" }}>
            {name}
            {Object.keys(displayData).length !== 0 ? (<Chart  height={"100px"} width={"inherit"} autoFit data={displayData[name]}
                   padding={[30, 30, 50, 50]}>

              <Axis name={"nazwa_regionu"} label={{ rotate: 0.5, autoRotate: true, style: {textAlign: 'start', fontSize: 10 } }}/>
                                <Axis name={"wartosc_wskaznika"}/>
                                <Axis name={"range"}/>
                                <Tooltip
                                    showTitle={false}
                                    showMarkers={false}
                                    itemTpl={'<li class="g2-tooltip-list-item" data-index={index} style="margin-bottom:4px;">'
                                    + '<span style="background-color:{color};" class="g2-tooltip-marker"></span>'
                                    + '{name}<br/>'
                                    + '<span style="padding-left: 16px">MAX?{high}</span><br/>'
                                    + '<span style="padding-left: 16px">G�rny?{q3}</span><br/>'
                                    + '<span style="padding-left: 16px">MEDIANA?{median}</span><br/>'
                                    + '<span style="padding-left: 16px">DOLNY?{q1}</span><br/>'
                                    + '<span style="padding-left: 16px">MIN?{low}</span><br/>'
                                    + '<span style="padding-left: 16px">Warto�� twojej jednostki?{wartosc_wskaznika}</span><br/>'
                                    + '</li>'}
                                />

                                <Legend visible={true}/>
                                <Schema
                                    position={'nazwa_regionu*range'}
                                    shape={'box'}
                                    style={{
                                        stroke: '#545454',
                                        fill: '#2ba9cd',
                                        fillOpacity: 1
                                    }}
                                    tooltip={[
                                        'nazwa_regionu*low*median*q3*q1*high',
                                        (nazwa_regionu, low, median, q3, q1, high) => {
                                            return {
                                                name: nazwa_regionu,
                                                low,
                                                q1,
                                                median,
                                                q3,
                                                high,
                                            };
                                        }
                                    ]}


                                />
            </Chart>)
            :
            <></>}
        </Card>


    )

};
// export default IndicatorList

export default SingleSlidePlot